<template>
    <div name="sign-up" class="sign-up">
        <agreement 
            v-if="step === 0"
            @next="next"
        />
        <input-phone 
            v-if="step === 1"
            @back="back"
        />
    </div>
</template>

<script>
import Agreement from '@/components/showcase/Agreement';
import InputPhone from '@/components/showcase/InputPhone';
// 0. 휴대전화번호
// 1. 약관페이지
export default {
  components: { Agreement, InputPhone },
    name: 'signUp',
    data: function()
    {
        return {
            step: 0
        }
    },
    mounted: function()
    {
        //진입시 home으로 이동 카운트 
        // this.resetTimeoutCount();
    },
    methods: {
        next: function(step)
        {
            this.step = step
        },
        back: function()
        {
            this.step = 0
        }
    }
   
}
</script>

<style scoped>
    .sign-up {
        width: 100%;
        height: 100vh;
        overflow: hidden;
    }
    
</style>


// WEBPACK FOOTER //
// src/page/showcase/SignUp.vue